"use client";

import { ArrowLeft, ArrowRight } from "lucide-react";
import { teamMembers } from "@/app/(site)/data/dataMembers";
import TeamCard from "../cards/TeamCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import Link from "next/link";

export default function TeamSection() {
    return (
        <div className="flex flex-col md:flex-row items-start justify-start w-full bg-gray-200 gap-10 md:pl-20 md:py-24">

            {/* top section */}
            <div
                className="flex flex-col md:w-[350px] w-full items-start justify-center md:px-14 py-10 md:py-28 text-white relative"
                style={{
                    backgroundImage: "url('/images/lawwyer.jpg')",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                }}
            >
                <div className="bg-primary/80 inset-0 absolute" />

                <div className="flex-col flex-1 w-full space-y-6 z-10">
                    <h3 className="text-4xl font-bold leading-12 text-secondary">
                        Meet our team
                    </h3>
                    <p className="text-lg font-light">
                        Esteemed professionals committed to protecting what matters most to you, with compassion, clarity, and confidence.
                    </p>
                    <Link href="/team">
                        <button className="flex items-center justify-center mt-2 text-base gap-4 text-black bg-secondary px-6 py-3 uppercase font-medium">
                            view all <ArrowRight />
                        </button>
                    </Link>
                    
                </div>
            </div>

            {/* slider */}
            <div className="flex-1 flex-col w-full overflow-hidden space-y-6"> 
                <div className="flex w-full gap-4">
                    {teamMembers.slice(0, 4).map((member, index) => (
                        <div key={index}>
                            <TeamCard member={member} />
                        </div>
                    ))}
                </div>

                    {/* arrows */}
                    <div className="flex items-end justify-between w-full py-5 pr-24">
                        <hr className="border-1 border-primary w-[80%]" />
                        <div className="flex gap-4">
                            <button className="team-swiper-button-prev flex items-center justify-center gap-5 text-black bg-secondary px-4 py-3">
                                <ArrowLeft />
                            </button>
                            <button className="team-swiper-button-next flex items-center justify-center gap-5 text-black bg-secondary px-4 py-3">
                                <ArrowRight />
                            </button>
                        </div>
                    </div>
                
            </div>
        </div>
    );
}
